module.exports = "//d274d294w9cx2v.cloudfront.net/39ba4dc632398fb91c594a0d3b88fd9f740d3e79/images/payPalBadge.png";